import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BookOpen } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("editorial@demo.com");
  const [password, setPassword] = useState("editorial2026");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError(""); setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (!r.ok) setError(r.error || "No se pudo iniciar sesión");
  }

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left: image / editorial */}
      <div
        className="hidden md:block relative"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/17910625/pexels-photo-17910625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900)",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-[#FAF9F5]/75 backdrop-blur-[2px]" />
        <div className="absolute inset-0 flex flex-col justify-between p-12">
          <div className="flex items-center gap-3 text-ink">
            <BookOpen size={20} strokeWidth={1.5} />
            <span className="font-heading text-lg tracking-tight">Editorial Infantil</span>
          </div>
          <div>
            <div className="font-heading text-4xl lg:text-5xl leading-[1.05] text-ink max-w-md">
              Control de stock, depósito y liquidaciones,
              <span className="text-brand"> sin Excel.</span>
            </div>
            <div className="mt-6 text-ink2 text-sm max-w-sm">
              Una herramienta ligera para editoriales independientes que priorizan la claridad y la trazabilidad.
            </div>
          </div>
          <div className="text-xs text-ink2 font-mono">v1.0 · España · EUR</div>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-8 paper-bg">
        <form
          onSubmit={onSubmit}
          data-testid="login-form"
          className="w-full max-w-sm bg-surface border border-line rounded-sm p-8"
        >
          <div className="mb-7">
            <h1 className="font-heading text-3xl text-ink leading-tight">Iniciar sesión</h1>
            <p className="text-sm text-ink2 mt-1">Acceso interno para el equipo.</p>
          </div>
          <label className="block">
            <span className="text-[11px] uppercase tracking-[0.12em] text-ink2">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
              className="mt-1 w-full bg-white border border-line rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand"
            />
          </label>
          <label className="block mt-4">
            <span className="text-[11px] uppercase tracking-[0.12em] text-ink2">Contraseña</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              required
              className="mt-1 w-full bg-white border border-line rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand"
            />
          </label>
          {error && (
            <div className="mt-4 text-sm text-crimson bg-crimson/5 border border-crimson/20 rounded-sm px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            data-testid="login-submit"
            className="mt-6 w-full bg-brand hover:bg-brand-hover disabled:opacity-60 text-white text-sm font-medium py-2.5 rounded-sm transition-colors"
          >
            {submitting ? "Entrando…" : "Entrar"}
          </button>
          <div className="mt-6 text-xs text-ink2 leading-relaxed">
            <strong className="text-ink">Demo:</strong> <span className="font-mono">editorial@demo.com</span> / <span className="font-mono">editorial2026</span>
          </div>
        </form>
      </div>
    </div>
  );
}
